import Vue from "vue"
import App from "./App"
import router from "./router"
import store from "./store"
import vuetify from "./plugins/vuetify"
import "./styles/global.scss"
import i18n from "./i18n"
import "izitoast/dist/css/iziToast.min.css"
import Notifications from "./plugins/notifications"
import GenericServices from "./plugins/generics"
import LoadScript from "./plugins/loadScript"
import NProgress from "vue-nprogress"
import VueNumericInput from "vue-numeric-input"

Vue.config.productionTip = false

Vue.use(VueNumericInput)
Vue.use(Notifications)
Vue.use(GenericServices)
Vue.use(LoadScript)
Vue.use(NProgress)
const nprogress = new NProgress()
const init = async () => {
  document.title = 'מבט תנכ"י'
  new Vue({
    nprogress,
    router,
    store,
    vuetify,
    i18n,
    render: (h) => h(App),
  }).$mount("#app")
}

init()
